export const sortPaintings = async (newPaintings, setPaintings) => {
  setPaintings(newPaintings)
  const formData = new FormData()
  formData.append('data', JSON.stringify({ paintings: newPaintings }))
  const response = await fetch('api/sort', {
    method: 'POST',
    body: formData,
  })
}
